import { spaceUsersListUrl } from "@Services/dataManager";
import { renderUserTag } from "@CubeComponents/html/userTagDom";
import { useRef, useMemo } from "react";

import SlickGrid1 from "@CubeComponents/html/SlickGrid1";
import { typedColumns, type GridRowBase } from "@CubeComponents/html/SlickGrid/types";
import { useTranslation } from "@i18n";

/** Row type for space user data */
interface SpaceUserRow extends GridRowBase {
  userName?: string;
  fullName?: string;
  companyName?: string;
  userId?: string;
}

function UsersListInSpace({ spaceId, selectUsers, disabledUserIds = [] }: any) {
  const dataGrid = useRef<any>(null);
  const { t } = useTranslation();

  const spaceUsersQuery = useMemo(
    () => ({
      spaceId,
      params: {
        spaceId,
      },
    }),
    [spaceId],
  );
  const selectionEvents = (args: any) => {
    const rowData = dataGrid.current.slickGrid.getDataItem(args.detail.args.rows[0]);
    if (rowData) {
      if (disabledUserIds.includes(rowData.userId)) {
        args.cancel = true;
        return;
      }

      const selectedRecords = dataGrid.current.dataView.getAllSelectedItems();
      selectUsers(selectedRecords);
    }
  };

  const userNameTemplate = (
    _row: number,
    _cell: number,
    _value: string | undefined,
    _columnDef: unknown,
    dataContext: SpaceUserRow,
  ) => {
    const container = document.createElement("div");
    const { userId } = dataContext;

    renderUserTag(container, { id: userId });
    return container;
  };

  const columnDefinitions = useMemo(
    () =>
      typedColumns<SpaceUserRow>([
        {
          field: "userName",
          id: "fullName",
          name: t("Users"),
          _valueGetter: (params) => params.fullName,
          formatter: userNameTemplate,
          filterType: "Text",
        },
        {
          field: "companyName",
          id: "company",
          name: t("Organization"),
          filterType: "Text",
          _valueGetter: (params) => params.companyName,
        },
      ]),
    [],
  );

  if (!spaceId) {
    return null;
  }

  return (
    <div className="h-[18.75rem]">
      <SlickGrid1
        ref={dataGrid}
        remoteDataSource={spaceUsersListUrl}
        query={spaceUsersQuery}
        columnDefinitions={columnDefinitions as any}
        disabledIds={disabledUserIds}
        enableFilteringOption
        onSelectedRowIdsChanged={selectionEvents}
      />
    </div>
  );
}

export default UsersListInSpace;
